export enum ModalSize {
  DEFAULT = 'default',
  COMPACT = 'compact'
}
